(() => {
'use strict';
if (!document.body.hasAttribute('data-ofk-us-replica') || window.__ofkReplicaVisualsInitialized) return;
window.__ofkReplicaVisualsInitialized = true;
// Source: src/components/SiteHeader.astro
try { (() => {
"use strict";
const header = document.querySelector(".site-header");
if (header) {
    let frame = 0;
    const syncHeaderBottom = () => {
        frame = 0;
        const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        document.documentElement.style.setProperty("--ofk-header-bottom", `${bottom}px`);
    };
    const scheduleSync = () => {
        if (!frame)
            frame = window.requestAnimationFrame(syncHeaderBottom);
    };
    syncHeaderBottom();
    window.addEventListener("scroll", scheduleSync, { passive: true });
    window.addEventListener("resize", scheduleSync);
    document.addEventListener("ofk:layout-change", scheduleSync);
    document.addEventListener("ofk:consent-resolved", scheduleSync);
    const disclosures = [
        ...header.querySelectorAll("details:not([data-nested-disclosure])"),
    ];
    for (const disclosure of disclosures) {
        disclosure.addEventListener("toggle", () => {
            if (disclosure.classList.contains("mobile-nav")) {
                disclosure
                    .querySelector(":scope > summary")
                    ?.setAttribute("aria-label", (disclosure.open ? disclosure.dataset.labelClose : disclosure.dataset.labelOpen) ??
                    `${disclosure.open ? "Close" : "Open"} navigation`);
            }
            if (!disclosure.open) {
                for (const nested of disclosure.querySelectorAll("details[data-nested-disclosure]")) {
                    nested.open = false;
                }
                return;
            }
            for (const sibling of disclosures) {
                if (sibling !== disclosure)
                    sibling.open = false;
            }
        });
    }
    document.addEventListener("click", (event) => {
        if (event.target instanceof Node && !header.contains(event.target)) {
            for (const disclosure of disclosures)
                disclosure.open = false;
        }
    });
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            const activeElement = document.activeElement;
            const focusOwner = disclosures.find((disclosure) => disclosure.open && activeElement instanceof Node && disclosure.contains(activeElement));
            for (const disclosure of disclosures)
                disclosure.open = false;
            focusOwner?.querySelector(":scope > summary")?.focus();
        }
    });
}

})(); } catch (error) { console.warn("OFK replica SiteHeader unavailable", error); }

// Source: src/components/HeaderDropdown.astro
try { (() => {
"use strict";
const dropdowns = document.querySelectorAll(".header-dropdown");
for (const dropdown of dropdowns) {
    if (dropdown.dataset.hoverBound === "true")
        continue;
    dropdown.dataset.hoverBound = "true";
    let closeTimer;
    let buttonPinned = false;
    const trigger = dropdown.querySelector(".header-dropdown__trigger");
    const toggle = dropdown.querySelector(".header-dropdown__toggle");
    const menuLabel = trigger?.textContent?.trim() ?? "navigation";
    const setExpanded = (expanded) => {
        toggle?.setAttribute("aria-expanded", String(expanded));
        const template = (expanded ? dropdown.dataset.hideLabel : dropdown.dataset.showLabel) ??
            `${expanded ? "Hide" : "Show"} {menu} menu`;
        toggle?.setAttribute("aria-label", template.replace("{menu}", menuLabel));
    };
    const open = () => {
        window.clearTimeout(closeTimer);
        dropdown.classList.remove("is-dismissed");
        dropdown.classList.add("is-open");
        setExpanded(true);
        document.dispatchEvent(new CustomEvent("ofk:header-dropdown-open", { detail: { source: dropdown } }));
    };
    const close = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
            if (buttonPinned)
                return;
            dropdown.classList.remove("is-open");
            setExpanded(false);
        }, 320);
    };
    const dismiss = () => {
        window.clearTimeout(closeTimer);
        buttonPinned = false;
        dropdown.classList.add("is-dismissed");
        dropdown.classList.remove("is-open");
        setExpanded(false);
    };
    document.addEventListener("ofk:header-dropdown-open", (event) => {
        if (!(event instanceof CustomEvent) || event.detail?.source === dropdown)
            return;
        dismiss();
    });
    document.addEventListener("click", (event) => {
        if (event.target instanceof Node && !dropdown.contains(event.target))
            dismiss();
    });
    dropdown.addEventListener("mouseenter", open);
    dropdown.addEventListener("mouseleave", () => {
        dropdown.classList.remove("is-dismissed");
        close();
    });
    dropdown.addEventListener("focusin", (event) => {
        if (event.target === toggle)
            return;
        open();
    });
    dropdown.addEventListener("focusout", (event) => {
        if (event.relatedTarget instanceof Node && dropdown.contains(event.relatedTarget))
            return;
        if (buttonPinned) {
            dismiss();
            return;
        }
        close();
    });
    toggle?.addEventListener("click", () => {
        if (buttonPinned) {
            dismiss();
            return;
        }
        buttonPinned = true;
        open();
    });
    dropdown.addEventListener("keydown", (event) => {
        if (event.key !== "Escape")
            return;
        event.preventDefault();
        event.stopPropagation();
        dismiss();
        toggle?.focus();
    });
}

})(); } catch (error) { console.warn("OFK replica HeaderDropdown unavailable", error); }

// Source: src/components/ProductGallery.astro
try { (() => {
"use strict";
for (const gallery of document.querySelectorAll("[data-product-gallery]")) {
    const main = gallery.querySelector("[data-gallery-main]");
    const thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    if (!main)
        continue;
    for (const thumb of thumbs) {
        thumb.addEventListener("click", () => {
            const source = thumb.dataset.src;
            if (!source)
                return;
            const width = Number(thumb.dataset.width);
            const height = Number(thumb.dataset.height);
            if (width > 0 && height > 0) {
                main.width = width;
                main.height = height;
            }
            if (thumb.dataset.srcset) {
                main.setAttribute("srcset", thumb.dataset.srcset);
                main.setAttribute("sizes", thumb.dataset.sizes || "100vw");
            } else {
                main.removeAttribute("srcset");
                main.removeAttribute("sizes");
            }
            main.src = source;
            main.alt = thumb.dataset.alt ?? "Product image";
            for (const item of thumbs) {
                const active = item === thumb;
                item.classList.toggle("is-active", active);
                item.setAttribute("aria-pressed", String(active));
            }
        });
    }
}

})(); } catch (error) { console.warn("OFK replica ProductGallery unavailable", error); }

// Source: src/components/LoopingCaptionFilm.astro
try { (() => {
"use strict";
const films = document.querySelectorAll("[data-looping-caption-film]");
for (const film of films) {
    if (film.dataset.filmReady === "true")
        continue;
    film.dataset.filmReady = "true";
    const video = film.querySelector("[data-looping-video]");
    const captions = film.querySelectorAll("[data-looping-caption]");
    if (!video)
        continue;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const connection = navigator.connection;
    const saveData = connection?.saveData === true;
    let inPlaybackRange = !video.hasAttribute("data-deferred");
    let policyPausePending = false;
    let userPaused = false;
    let userActivated = !saveData;
    let explicitMotionApproval = false;
    let playbackRetryPending = false;
    const pauseForPolicy = () => {
        if (video.paused)
            return;
        policyPausePending = true;
        video.pause();
    };
    const syncCaptions = () => {
        const currentTime = video.currentTime;
        for (const caption of captions) {
            const start = Number(caption.dataset.start ?? 0);
            const end = Number(caption.dataset.end ?? 0);
            caption.toggleAttribute("data-active", currentTime >= start && currentTime < end);
        }
    };
    const beginMutedPlayback = (explicit = false) => {
        if ((reducedMotion.matches && !(explicit && explicitMotionApproval)) ||
            (saveData && !userActivated) ||
            document.visibilityState === "hidden" ||
            !inPlaybackRange ||
            userPaused) {
            pauseForPolicy();
            return;
        }
        video.muted = true;
        void video.play().catch(() => {
        });
    };
    const loadDeferredVideo = () => {
        if (saveData && !userActivated)
            return;
        const source = video.querySelector("source[data-src]");
        const deferredSource = source?.dataset.src;
        if (!source || !deferredSource || source.hasAttribute("src"))
            return;
        source.src = deferredSource;
        video.dataset.videoLoaded = "true";
        video.load();
    };
    const playFromUser = async () => {
        userActivated = true;
        explicitMotionApproval = reducedMotion.matches;
        userPaused = false;
        loadDeferredVideo();
        video.muted = true;
        if (video.readyState < HTMLMediaElement.HAVE_FUTURE_DATA && !playbackRetryPending) {
            playbackRetryPending = true;
            video.addEventListener("canplay", () => {
                playbackRetryPending = false;
                beginMutedPlayback(true);
            }, { once: true });
        }
        beginMutedPlayback(true);
    };
    const needsManagedStart = () => {
        const source = video.querySelector("source[data-src]");
        return (Boolean(source?.dataset.src && !source.hasAttribute("src")) ||
            (saveData && !userActivated) ||
            (reducedMotion.matches && video.paused));
    };
    syncCaptions();
    video.addEventListener("click", (event) => {
        if (!needsManagedStart())
            return;
        event.preventDefault();
        void playFromUser();
    }, { capture: true });
    video.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ")
            return;
        if (!needsManagedStart())
            return;
        event.preventDefault();
        void playFromUser();
    });
    video.addEventListener("loadedmetadata", syncCaptions);
    video.addEventListener("timeupdate", syncCaptions);
    video.addEventListener("seeked", syncCaptions);
    video.addEventListener("pause", () => {
        if (policyPausePending) {
            policyPausePending = false;
            return;
        }
        userPaused = true;
    });
    video.addEventListener("play", () => {
        userPaused = false;
    });
    reducedMotion.addEventListener("change", () => {
        if (reducedMotion.matches) {
            explicitMotionApproval = false;
            pauseForPolicy();
        }
        else
            beginMutedPlayback();
    });
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden")
            pauseForPolicy();
        else
            beginMutedPlayback();
    });
    if (video.hasAttribute("data-deferred")) {
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(([entry]) => {
                inPlaybackRange = entry?.isIntersecting === true;
                if (inPlaybackRange) {
                    if (!saveData || userActivated)
                        loadDeferredVideo();
                    beginMutedPlayback();
                }
                else {
                    pauseForPolicy();
                }
            }, { rootMargin: "320px 0px", threshold: 0.01 });
            observer.observe(film);
        }
        else {
            inPlaybackRange = true;
            if (!saveData || userActivated)
                loadDeferredVideo();
            beginMutedPlayback();
        }
    }
    else {
        if (!saveData || userActivated)
            loadDeferredVideo();
        beginMutedPlayback();
    }
}

})(); } catch (error) { console.warn("OFK replica LoopingCaptionFilm unavailable", error); }

// Source: src/components/MotionAwareVideo.astro
try { (() => {
"use strict";
const videos = document.querySelectorAll("[data-motion-aware-video]");
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
for (const video of videos) {
    if (video.dataset.motionBound === "true")
        continue;
    video.dataset.motionBound = "true";
    const autoplayRequested = video.hasAttribute("data-autoplay-requested");
    const connection = navigator.connection;
    const saveData = connection?.saveData === true;
    let inPlaybackRange = !video.hasAttribute("data-deferred");
    let policyPausePending = false;
    let userPaused = false;
    let userActivated = !saveData;
    let userStarted = false;
    let explicitMotionApproval = false;
    let playbackRetryPending = false;
    const pauseForPolicy = () => {
        if (video.paused)
            return;
        policyPausePending = true;
        video.pause();
    };
    const beginMutedPlayback = (explicit = false) => {
        if ((reducedMotion.matches && !(explicit && explicitMotionApproval)) ||
            (saveData && !userActivated) ||
            document.visibilityState === "hidden" ||
            !inPlaybackRange ||
            userPaused ||
            (!autoplayRequested && !userStarted && !explicit)) {
            pauseForPolicy();
            return;
        }
        video.muted = true;
        void video.play().catch(() => {
        });
    };
    const loadDeferredVideo = () => {
        if (saveData && !userActivated)
            return;
        const source = video.querySelector("source[data-src]");
        const deferredSource = source?.dataset.src;
        if (!source || !deferredSource || source.hasAttribute("src"))
            return;
        source.src = deferredSource;
        video.dataset.videoLoaded = "true";
        video.load();
    };
    const playFromUser = async () => {
        userActivated = true;
        userStarted = true;
        explicitMotionApproval = reducedMotion.matches;
        userPaused = false;
        loadDeferredVideo();
        video.muted = true;
        if (video.readyState < HTMLMediaElement.HAVE_FUTURE_DATA && !playbackRetryPending) {
            playbackRetryPending = true;
            video.addEventListener("canplay", () => {
                playbackRetryPending = false;
                beginMutedPlayback(true);
            }, { once: true });
        }
        beginMutedPlayback(true);
    };
    const needsManagedStart = () => {
        const source = video.querySelector("source[data-src]");
        return (Boolean(source?.dataset.src && !source.hasAttribute("src")) ||
            (saveData && !userActivated) ||
            (reducedMotion.matches && video.paused));
    };
    video.addEventListener("click", (event) => {
        if (!needsManagedStart())
            return;
        event.preventDefault();
        void playFromUser();
    }, { capture: true });
    video.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ")
            return;
        if (!needsManagedStart())
            return;
        event.preventDefault();
        void playFromUser();
    });
    video.addEventListener("pause", () => {
        if (policyPausePending) {
            policyPausePending = false;
            return;
        }
        userPaused = true;
    });
    video.addEventListener("play", () => {
        if (!autoplayRequested)
            userStarted = true;
        userPaused = false;
    });
    reducedMotion.addEventListener("change", () => {
        if (reducedMotion.matches) {
            explicitMotionApproval = false;
            pauseForPolicy();
        }
        else
            beginMutedPlayback();
    });
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden")
            pauseForPolicy();
        else
            beginMutedPlayback();
    });
    if (video.hasAttribute("data-deferred") && "IntersectionObserver" in window) {
        const observer = new IntersectionObserver(([entry]) => {
            inPlaybackRange = entry?.isIntersecting === true;
            if (inPlaybackRange) {
                if (!saveData || userActivated)
                    loadDeferredVideo();
                if (autoplayRequested || userStarted)
                    beginMutedPlayback();
            }
            else {
                pauseForPolicy();
            }
        }, { rootMargin: "320px 0px", threshold: 0.01 });
        observer.observe(video);
    }
    else {
        inPlaybackRange = true;
        if (!saveData || userActivated)
            loadDeferredVideo();
        if (autoplayRequested || userStarted)
            beginMutedPlayback();
    }
}

})(); } catch (error) { console.warn("OFK replica MotionAwareVideo unavailable", error); }

// Source: src/components/HimariDetail.astro
try { (() => {
"use strict";
const stickyPurchase = document.querySelector("[data-himari-page] .himari-sticky");
const soraUpgrade = document.querySelector("[data-himari-page] .himari-sora");
const footer = document.querySelector(".site-footer--home");
if (stickyPurchase && soraUpgrade && footer && "IntersectionObserver" in window) {
    const visibleTargets = new Set();
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting)
                visibleTargets.add(entry.target);
            else
                visibleTargets.delete(entry.target);
        });
        stickyPurchase.classList.toggle("is-hidden", visibleTargets.size > 0);
    }, { rootMargin: "0px 0px 76px 0px", threshold: 0 });
    observer.observe(soraUpgrade);
    observer.observe(footer);
}

})(); } catch (error) { console.warn("OFK replica HimariDetail unavailable", error); }

// Source: src/components/ProductDetail.astro
try { (() => {
"use strict";
const sticky = document.querySelector("[data-product-sticky]");
const firstBuy = document.querySelector(".product-overview [data-buy-link]");
const finalCta = document.querySelector(".product-final-cta");
const footer = document.querySelector(".site-footer");
if (sticky) {
    let frame = 0;
    const update = () => {
        frame = 0;
        const viewport = window.innerHeight;
        const passedFirstBuy = firstBuy ? firstBuy.getBoundingClientRect().bottom < 0 : window.scrollY > viewport;
        const closingInView = [finalCta, footer].some((target) => target && target.getBoundingClientRect().top < viewport);
        sticky.classList.toggle("is-hidden", !passedFirstBuy || closingInView);
    };
    const schedule = () => {
        if (!frame)
            frame = window.requestAnimationFrame(update);
    };
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    update();
}

})(); } catch (error) { console.warn("OFK replica ProductDetail unavailable", error); }

// Source: src/components/SiteFooter.astro
try { (() => {
"use strict";
const mobileFooter = window.matchMedia("(max-width: 1100px), (pointer: coarse)");
const footerColumns = document.querySelectorAll(".site-footer--home .site-footer__home-column");
const syncFooterColumns = () => {
    for (const column of footerColumns)
        column.open = !mobileFooter.matches;
};
syncFooterColumns();
mobileFooter.addEventListener("change", syncFooterColumns);

})(); } catch (error) { console.warn("OFK replica SiteFooter unavailable", error); }

// Source: src/components/ScrollRegionEnhancer.astro
try { (() => {
"use strict";
const regions = [...document.querySelectorAll("[data-scroll-region]")];
const syncScrollRegions = () => {
    for (const region of regions) {
        region.tabIndex = region.scrollWidth > region.clientWidth + 1 ? 0 : -1;
    }
};
syncScrollRegions();
window.addEventListener("load", syncScrollRegions, { once: true });
if ("ResizeObserver" in window) {
    const resizeObserver = new ResizeObserver(syncScrollRegions);
    regions.forEach((region) => resizeObserver.observe(region));
}

})(); } catch (error) { console.warn("OFK replica ScrollRegionEnhancer unavailable", error); }


// Size selection is visual state only. The parent commerce module owns prices and cart operations.
const syncSize = (key, size, notify = true) => {
  const radios = [...document.querySelectorAll('[data-ofk-replica-size]')].filter(radio => radio.dataset.ofkProduct === key);
  if (!radios.some(radio => radio.dataset.ofkSize === size && !radio.disabled)) return;
  for (const radio of radios) radio.checked = radio.dataset.ofkSize === size;
  for (const trigger of document.querySelectorAll('[data-ofk-replica-buy]')) {
    if (trigger.dataset.ofkProduct !== key) continue;
    trigger.dataset.ofkSize = size;
    if (trigger.getAttribute('href') !== '#ofk-replica-purchase') {
      const url = new URL(trigger.href, location.href);
      url.searchParams.set('size', size);
      trigger.href = url.href;
    }
  }
  if (notify) document.dispatchEvent(new CustomEvent('ofk:replica-size-change', { detail: { product: key, size } }));
};
document.addEventListener('change', event => {
  const radio = event.target;
  if (radio instanceof HTMLInputElement && radio.matches('[data-ofk-replica-size]') && radio.checked) syncSize(radio.dataset.ofkProduct, radio.dataset.ofkSize);
});
const main = document.querySelector('[data-ofk-replica-product]');
const size = new URL(location.href).searchParams.get('size');
if (main && size) syncSize(main.dataset.ofkReplicaProduct, size, false);

})();
